import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e917a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-search-input-container" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "vau-content" }
const _hoisted_5 = { class: "vau-icon" }

import Loading from '@/components/Loading.vue'
import { Ref, computed, onMounted, ref } from 'vue'
import { listSwitchUsers, switchUser } from '@/mobile/src/api/auth'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import {
    faCircleCheck,
    faMagnifyingGlass,
} from 'fontawesome/free-solid-svg-icons'
import store from '@/mobile/src/store'
import router from '@/mobile/src/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewAs',
  setup(__props) {

const pageLoading = ref(false)
const viewAsUsers: Ref<any[]> = ref([])
const searchText = ref('')
const usersearch: Ref<HTMLElement | null> = ref(null)

onMounted(async () => {
    pageLoading.value = true
    const result = await listSwitchUsers()
    viewAsUsers.value.push(...result.data.users)
    pageLoading.value = false
})

const userId = computed(() => store.getters['userId'])
const userHasMlp = computed(() => store.getters['userHasMlp'])
const filteredUsers = computed(() => {
    if (!searchText.value) {
        return viewAsUsers.value
    }
    return viewAsUsers.value.filter((user) => {
        const lowerName = user.name.toLowerCase()
        const lowerSearch = searchText.value.toLowerCase()
        const lowerIndex = lowerName.indexOf(lowerSearch)
        return lowerIndex === 0
    })
})

function focusInput() {
    usersearch.value?.focus()
}

async function viewAsSomeoneElse(toUserId: string | number) {
    pageLoading.value = true
    await switchUser(userId.value === toUserId ? '_exit' : toUserId)
    await router.push({ name: userHasMlp.value ? 'evenmore' : 'more' })
    window.location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["view-as-container", { 'no-mlp': !userHasMlp.value }])
  }, [
    (pageLoading.value)
      ? (_openBlock(), _createBlock(Loading, {
          key: 0,
          loading: pageLoading.value
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "vau user-search",
      onClick: focusInput
    }, [
      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faMagnifyingGlass) }, null, 8, ["icon"]),
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("input", {
          ref_key: "usersearch",
          ref: usersearch,
          value: searchText.value,
          class: "user-search-input",
          type: "text",
          onInput: _cache[0] || (_cache[0] = (e) => (searchText.value = e.target.value))
        }, null, 40, _hoisted_2),
        _withDirectives(_createVNode(Typography, {
          class: "user-search-placeholder",
          variant: "overline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Search... ")
          ], undefined, true),
          _: 1
        }, 512), [
          [_vShow, !searchText.value]
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        key: user.id,
        class: "vau",
        onClick: ($event: any) => (viewAsSomeoneElse(user.id))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Typography, {
            class: "vau-text user-name",
            variant: "overline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(user.name), 1)
            ], undefined, true),
            _: 2
          }, 1024),
          _createVNode(Typography, {
            class: "vau-text user-type",
            variant: "body2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(user.usertypeName), 1)
            ], undefined, true),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_5, [
            (user.id === userId.value)
              ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                  key: 0,
                  icon: _unref(faCircleCheck)
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 8, _hoisted_3))
    }), 128))
  ], 2))
}
}

})